import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { BillRoutinePage } from '~/features/routines/bill-routine-page';

function BillRoute(): ReactElement {
  const { ruleId } = Route.useParams();
  return <BillRoutinePage key={ruleId} ruleId={ruleId} />;
}

/** A monthly run, on its own page (docs/plans/routines.md R6, R7). */
export const Route = createFileRoute('/_app/routines/bill/$ruleId')({
  component: BillRoute,
});
